export const DOCUMENT_TYPES = {
    // Personal Data
    VOLLMACHT: 'Vollmacht',
    REISEPASS: 'Reisepass',
    LEBENSLAUF: 'Lebenslauf',
    SPRACHNACHWEIS: 'Sprachnachweis Deutsch',
    GEBURTSURKUNDE: 'Geburtsurkunde',
    HEIRATSURKUNDE: 'Heiratsurkunde',
    STRAFREGISTER: 'Strafregisterauszug',

    // Education
    POSTSECONDARY: 'Nachweis der Anerkennung als ausländische postsekundäre Bildungseinrichtung',
    PRAKTIKUM: 'Praktikumsnachweise Studium',
    THESIS: 'Bachelor-/Abschlussarbeit',
    CURRICULUM: 'Curriculum',
    MATURA: 'Reife-/Maturazeugnis',
    DIPLOM: 'Abschluss bzw. Diplomurkunde des Studiums, Diploma Supplement',
    TRANSCRIPT: 'Transcript of Records',

    // Work Experience
    REGISTRATION: 'Registration Certificate, Berufslizenz, Eintragung ins Berufsregister',
    ARBEITSBESTAETIGUNG: 'Arbeitsbestätigung nach Studium',
} as const;

export type DocumentType = typeof DOCUMENT_TYPES[keyof typeof DOCUMENT_TYPES];